module.exports = "./img/67792cb47c8b24e2c9c5c51e7761366e.jpg";